import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { ExternalLink, Trash2, Heart } from "lucide-react";
import { toast } from "sonner";

export default function Favorites() {
  const [favs, setFavs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/favorites");
      setFavs(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/favorites/${id}`);
      setFavs((f) => f.filter((x) => x.id !== id));
      toast.success("Favori supprimé");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">
      <div className="mb-8">
        <div className="tape-label text-poppy">MES TROUVAILLES</div>
        <h1 className="font-display font-black text-4xl md:text-5xl">Favoris</h1>
        <p className="text-ink/60 mt-1">Tous les magasins que vous avez sauvegardés.</p>
      </div>

      {loading ? (
        <div className="text-ink/50">Chargement…</div>
      ) : favs.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {favs.map((f) => (
            <article
              key={f.id}
              data-testid={`favorite-${f.id}`}
              className="card-brut p-4 flex flex-col gap-3"
            >
              <div className="flex items-center justify-between">
                <span className="tape-label text-poppy">{f.merchant}</span>
                <button
                  data-testid={`delete-fav-${f.id}`}
                  onClick={() => remove(f.id)}
                  className="p-1.5 border border-ink/20 hover:bg-ink hover:text-linen"
                  aria-label="Supprimer"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              <div className="font-display font-bold text-lg leading-tight line-clamp-2">
                {f.title}
              </div>
              <a
                href={f.url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-brut px-3 py-2 text-xs flex items-center justify-center gap-1.5"
              >
                Ouvrir <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </article>
          ))}
        </div>
      )}
    </main>
  );
}

function EmptyState() {
  return (
    <div
      data-testid="empty-favorites"
      className="border border-dashed border-ink/30 p-12 text-center"
    >
      <Heart className="w-8 h-8 mx-auto text-poppy" />
      <div className="font-display font-black text-2xl mt-3">
        Aucun favori pour l'instant
      </div>
      <p className="text-ink/60 mt-1">
        Faites une recherche, puis cliquez sur le cœur d'un magasin pour le sauvegarder.
      </p>
    </div>
  );
}
